import React, { useEffect, useRef } from 'react';

const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 1 minute for testing

const InactivityHandler = ({ onTimeout }) => {
  const timerRef = useRef(null);

  // Reset the inactivity timer and log the reset and timer
  const resetTimer = () => {

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Log when the timeout will trigger
    const timeLeft = INACTIVITY_TIMEOUT / 1000; // In seconds

    timerRef.current = setTimeout(() => {
      onTimeout(); // Call the timeout function (e.g., logout or warning)
    }, INACTIVITY_TIMEOUT);
  };

  useEffect(() => {

    // Events to monitor
    const events = ['mousemove', 'keydown', 'scroll', 'click'];

    // Attach all event listeners
    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    // Start the initial timer when the component mounts
    resetTimer();

    // Cleanup function: Remove event listeners when the component unmounts
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return null; // No UI component
};

export default InactivityHandler;
